<template>
    <div>
        <div class="page-title">提出修改記錄 Request</div>
        <el-card class="box-card">
             <el-table
                :data="applications"
                style="width: 100%;">
                <el-table-column
                    prop="createdAt"
                    label="Request Date 發出日期"
                    >
                    <template slot-scope="{row}">
                         <span>{{row.createdAt | formatDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="detail"
                    label="Request Details 修改內容">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="Request Status 修改狀態">
                    <template slot-scope="{row}">
                        <span>{{row.status | status }}</span>
                    </template>
                </el-table-column>
             </el-table>

        </el-card>

        <div class="copyright-card">
            <copyrightCard></copyrightCard>
        </div>
    </div>
</template>

<script>
    import {getRequestFromApplications} from '@/api/parent/application'
    import copyrightCard from '@/components/copyrightCard'
    export default {
        components: { copyrightCard },
        filters:{
            status(val){
                switch (val) {
                    case 0:
                    return 'In process'
                    case 1:
                    return 'Solved'
                }
            }
        },
        data() {
            return {
                applications: []
            }
        },
        created(){
            this.getRequestFromApplications()
        },
        methods:{
            getRequestFromApplications(){
                getRequestFromApplications().then((v)=>{
                     this.applications = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.home-title{
    color: #337AB7;
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 30px;
}
.box-card{
    margin-bottom: 30px;
}
.copyright-card{
    background-color: #fff;
}
</style>